<template>
  <div class="ponuda" id="ponuda">
    <div class="wrapper">

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ponuda',
  components: {
  },
  props: {
    id: String
  }
}
</script>
<style lang="scss" scoped>
.ponuda{
  position: absolute;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  top: 0px;
  left: 0px;
  padding: 4.8vw 0.6vw 2.4vw;
  z-index: 100;
  background-color: #f8f9fa;
  scroll-behavior: smooth;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.ponuda::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.ponuda{
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.wrapper{
  position: relative;
  width: 65.5vw;
  margin: 0px auto;
}

@media only screen and (max-width: 600px) {
.ponuda{
  position: relative;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  top: 0px;
  left: 0px;
  padding: 4.8vw 0.6vw 2.4vw;
  z-index: 100;
  background-color: #f8f9fa;
}

  .wrapper{
    position: relative;
    width: 100%;
    margin: 0px auto;
  }
}

.item{
  width: 435px;
  height: 230px;
  background-color: #fff;
  position: relative;
  margin: 8px 0px;
  border-radius: 8px;
}

</style>
